export function initCuratorForm(){
    const nextButton = document.querySelector<HTMLButtonElement>('.curator-next-button');
    const curatorNext = document.querySelector<HTMLElement>('.curator-next');
    const curatorForm = document.querySelector<HTMLElement>('.modal-curator-form');

    if (!nextButton || !curatorNext || !curatorForm) return;

    nextButton.addEventListener('click', () => {
        // --- 1. Схлопываем блок с кнопкой ---
        const nextHeight = curatorNext.scrollHeight;
        curatorNext.style.height = nextHeight + 'px';

        requestAnimationFrame(() => {
            curatorNext.style.height = '0px';
            curatorNext.style.opacity = '0';
        });

        // --- 2. Раскрываем форму ---
        curatorForm.classList.add('is-open');

        const formHeight = curatorForm.scrollHeight;
        curatorForm.style.height = formHeight + 'px';
        curatorForm.style.opacity = '1';

        // После анимации убираем фиксированную высоту
        setTimeout(() => {
            curatorForm.style.height = 'auto';
            curatorNext.style.display = 'none';
        }, 400);
    });
}